module.exports = {"Operate25":{"daobanList":[{"title":"1、是否办理非药品类易制毒化学品经营一件事","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、非药品类易制毒化学品生产、经营申请书","state":"必要"},{"name":"2、危险化学品经营企业经营许可证申请书","state":"必要"},{"name":"3、工商营业执照副本","state":"容缺受理"},{"name":"4、易制毒化学品管理制度","state":"必要"},{"name":"5、产品包装说明和使用说明书","state":"必要"},{"name":"6、安全生产规章制度和岗位操作规程的目录清单","state":"必要"},{"name":"7、特种作业操作证","state":"必要"},{"name":"8、不动产权电子证书","state":"必要"},{"name":"9、危险化学品事故应急预案备案登记表","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdo-25.json
// module id = 1283
// module chunks = 0